import { Atom, atom } from "jotai"
import { loadable } from "jotai/utils"
import { matchPath } from "react-router"

import { findMatchRoute, routes } from "packages/route"

import { ExtraMenuGroup, MenuItemUnion } from "./types"

/**
 * 是否是菜单组
 *
 * @param menu - 菜单数据
 * @returns 是否
 */
export function isExtraMenuGroup(menu: MenuItemUnion): menu is ExtraMenuGroup {
  return !!(menu as any).subMenus
}

const loadableValue = loadable<MenuItemUnion[]>(atom(() => []))
type LoadableAtomType = typeof loadableValue;
export type MenuProvider = Atom<MenuItemUnion[]> | LoadableAtomType;

const menuProviders: MenuProvider[] = []

export const addMenuProvider = (p: MenuProvider) => {
  menuProviders.push(p)
}

/**
 * 依据路由匹配菜单项
 * @param path - 路由
 * @param menus - 菜单集
 * @param exact - 是否精确匹配
 * @returns - 菜单项
 */
export const matchMenu = (
  path: string,
  menus: MenuItemUnion[],
  exact = true
): MenuItemUnion | undefined => {
  /*
   * 考虑到动态路由，menu 中的 path 可能是子路由的情况，
   * 这里需要拿到路由的 path，再和和菜单的 path 模糊匹配
   */
  const route = findMatchRoute(path, routes)

  const findTargetMenu: (
    _menus: MenuItemUnion[]
  ) => MenuItemUnion | undefined = (_menus: MenuItemUnion[]) => {
    for (const menu of _menus) {
      let isMatched = false

      if ("path" in menu && menu.path) {
        isMatched = exact
          ? menu.path === path
          : !!matchPath(menu.path, {
              path: route?.path,
              exact: true,
              strict: false,
            })
      }

      if (isMatched) {
        return menu
      }

      if (isExtraMenuGroup(menu)) {
        const flag = findTargetMenu(menu.subMenus)
        if (flag) return flag
      }
    }

    return undefined
  }

  return findTargetMenu(menus)
}
